export class StringUtils {
	public static IsEmptyOrUndefined(value: string | undefined): boolean {
		if ((value === '') || (value === undefined)) {
			return true;
		}
		return false;
	}
}
